import { ValidationStatusEnum } from "../../../services/client/types.gen";
import { unreachable } from "../../../util/unreachable";

export const isReady = (status?: ValidationStatusEnum) => {
  switch (status) {
    case "WARNING":
    case "OK":
    case "UNKNOWN":
      return true;

    case "ERROR":
    case undefined:
      return false;

    default:
      return unreachable(status);
  }
};
